import founder from "../../../assets/images/Arun_Founder.jpeg";
import dbsLogo from "../../../assets/images/icons/dbs.png";
import cimbLogo from "../../../assets/images/icons/cimb.png";
import masLogo from "../../../assets/images/icons/mas.jpg";
import skillsfutureLogo from "../../../assets/images/icons/ssg.png";
import mbsLogo from "../../../assets/images/icons/mbs.png";
import azureLogo from "../../../assets/images/icons/azure.png";
import googleLogo from "../../../assets/images/icons/google.png";
import awsLogo from "../../../assets/images/icons/aws.png";
import clouderaLogo from "../../../assets/images/icons/cloudera.gif";
// import choose2 from "../../../assets/images/resource/choose-01.png";
// import choose3 from "../../../assets/images/resource/choose-01.png";
// import choose4 from "../../../assets/images/resource/choose-01.png";

const Choose = () => {
    return (
      <section className="choose__us p_relative mb-lg-5 mb-4">
        <div className="choose__us__data">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5 col-md-12 mb-4 mb-lg-0">
                <div className="choose__block align-items-center">
                  <img
                    src={founder}
                    alt="Arun profile"
                    className="img-fluid profile-img"
                  />
                </div>
              </div>

              <div className="col-lg-7 col-md-12">
                <div className="profile-content-wrap">
                  <p className="profile-intro">
                    Arun is a Data & AI Consultant at Smart iLab Works (SiW). He
                    holds an M.Tech in Advanced Computing and has around 16
                    years of experience as an IT Consultant in Singapore,
                    providing IT solutions across the telecom, banking,
                    government, hospitality, and finance sectors.
                  </p>

                  <div className="client-logos">
                    <img src={dbsLogo} alt="DBS" />
                    <img src={cimbLogo} alt="CIMB" />
                    <img src={masLogo} alt="MAS" />
                    <img src={skillsfutureLogo} alt="SkillsFuture" />
                    <img src={mbsLogo} alt="Marina Bay Sands" />
                  </div>

                  <p className="profile-certification">
                    He is trained and certified by Azure, Google, AWS and
                    Cloudera.
                  </p>

                  <div className="certification-icons">
                    <img src={azureLogo} alt="Microsoft Azure" />
                    <img src={googleLogo} alt="Google" />
                    <img src={awsLogo} alt="AWS" />
                    <img src={clouderaLogo} alt="Cloudera" />
                  </div>

                  <div className="contact-grid">
                    <div className="contact-box">
                      <i className="bi bi-telephone-fill"></i>
                      <a href="tel:+65 8660 5048">
                        <span>+65 8660 5048</span>
                      </a>
                    </div>

                    <div className="contact-box">
                      <i className="bi bi-envelope-fill"></i>
                      <a href="mailto:arun@siw.sg">
                        <span>arun@siw.sg</span>
                      </a>
                    </div>

                    <div className="contact-box">
                      <i className="bi bi-linkedin"></i>
                      <a
                        href="https://www.linkedin.com/in/arun-prasad-m-86951025/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span>Arun_in</span>
                      </a>
                    </div>

                    <div className="contact-box full-width">
                      <i className="bi bi-globe"></i>
                      <a
                        href="https://www.siw.sg"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span>www.siw.sg</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
};

export default Choose;